import React, { useEffect } from "react";
import { Carousel } from "react-bootstrap";
import axios from "axios";

const HomeSignatureLooksCarousel = () => {
  const [looks, setLooks] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const getLooks = async () => {
    try {
      const res = await axios.get(`/api/homeSignatureLook/getAll/`);
      setLooks(res.data?.homeSignatureLooks || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLooks();
  }, []);

  return (
    <div
      style={{
        color: "#FFFFFF",
        margin: "0rem 0rem",
        background: "#e1f3ff",
        paddingBottom: "1rem",
      }}
    >
      <div style={{ paddingTop: "0.5rem" }}>
        <span className="title">Signature Looks</span>
      </div>

      {loading && (
        <div className="d-flex justify-content-center mt-5">
          <div className="spinner-border text-dark" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}

      {!loading && looks.length === 0 && (
        <div className="d-flex justify-content-center">
          <h5 style={{ color: "#285979" }}>No Signature Looks added yet</h5>
        </div>
      )}

      {!loading && looks.length > 0 && (
        <Carousel
          vertical="horizontal"
          fade
          style={{ marginBottom: "1rem" }}
          interval={3000}
          autoPlay
          infiniteLoop
        >
          {looks.map((look) => (
            <Carousel.Item style={{ position: "relative" }} key={look._id}>
              <img
                className="carousel-campaign"
                src={look?.image[0]?.url}
                alt={look?.name || "signature look"}
                style={{
                  width: "100%",
                  display: "block",
                  padding: "0rem 0.5rem 0rem 0.5rem",
                  height: "auto",
                  maxHeight: "400px",
                  objectFit: "contain",
                }}
              />
              {look?.name && (
                <p
                  style={{
                    position: "absolute",
                    bottom: "0.75rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(1, 13, 27, 0.75)",
                    color: "white",
                    padding: "6px 16px",
                    fontWeight: "600",
                    fontSize: "clamp(0.8rem, 2.5vw, 1.3rem)",
                    fontFamily: "Raleway",
                    borderRadius: "4px",
                    margin: 0,
                    whiteSpace: "nowrap",
                    maxWidth: "90%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {look.name}
                </p>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default HomeSignatureLooksCarousel;
